import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const DownloadIcon = React.forwardRef(({ fill, height, viewBox, width, ...rest }, ref) => {
    return (
        <SvgIcon ref={ref} width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 14a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.293 9.293a1 1 0 0 1 1.414 0L12 13.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1z"
                fill={fill}
            />
        </SvgIcon>
    );
});

DownloadIcon.displayName = 'DownloadIcon';

DownloadIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

DownloadIcon.defaultProps = {
    fill: MIGRATED_COLORS.black,
    height: '24',
    viewBox: '0 0 24 24',
    width: '24',
};

export default DownloadIcon;
